import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderPriceList from '@hooks/useProviderPriceList'

import CreateOrEditProviderPriceListItemModal from '@modals/CreateOrEditProviderPriceListItemModal'
import CreateOrEditProviderPriceListItemOptionModal from '@modals/CreateOrEditProviderPriceListItemOptionModal'
import CreateOrEditProviderPriceListItemOptionValueModal from
  '@modals/CreateOrEditProviderPriceListItemOptionValueModal'

import usePriceListManager from './hooks/usePriceListManager'

import Editor from './components/Editor'
import PricingMatrix from './components/PricingMatrix'

interface PriceListManagerProps {
  providerPriceListPayload: ReturnType<typeof useProviderPriceList>,
  viewMode: 'editor' | 'matrix',
}

const PriceListManager = (props: PriceListManagerProps) => {
  const {
    providerPriceListPayload: { loading, providerPriceList },
    viewMode,
  } = props

  const priceListManagerPayload = usePriceListManager({
    providerPriceList,
  })

  const {
    callbacks: {
      modalCallbacks,
    },
    modalContext,
    state,
  } = priceListManagerPayload

  return (
    <PageContext.Provider value={priceListManagerPayload}>
      <ModalContext.Provider value={modalContext}>
        {viewMode === 'editor' && (
          <Editor
            loading={loading}
            priceListManagerPayload={priceListManagerPayload}
            providerPriceList={providerPriceList}
          />
        )}

        {viewMode === 'matrix' && (
          <PricingMatrix
            loading={loading}
            priceListManagerPayload={priceListManagerPayload}
            // @ts-expect-error TS2322
            providerPriceList={providerPriceList}
          />
        )}

        <CreateOrEditProviderPriceListItemModal
          callbacks={modalCallbacks('CreateOrEditProviderPriceListItemModal')}
          showModal={state.showCreateOrEditProviderPriceListItemModal}
        />

        <CreateOrEditProviderPriceListItemOptionModal
          callbacks={modalCallbacks('CreateOrEditProviderPriceListItemOptionModal')}
          showModal={state.showCreateOrEditProviderPriceListItemOptionModal}
        />

        <CreateOrEditProviderPriceListItemOptionValueModal
          callbacks={modalCallbacks('CreateOrEditProviderPriceListItemOptionValueModal')}
          showModal={state.showCreateOrEditProviderPriceListItemOptionValueModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default PriceListManager
